import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import File from './File.js';
import { MultiFileList } from './MultiFileList.js';
export const FileList = memo(function FileList({ error, isUploading, success, fileName, filesState, multi, progress, handleReset, tryAnotherText, }) {
    if (!multi) {
        return (fileName && (_jsx(File, { fileName: fileName, progress: progress, handleReset: handleReset, tryAnotherText: tryAnotherText, isUploading: isUploading, error: error, success: success })));
    }
    return _jsx(MultiFileList, { filesState: filesState, tryAnotherText: tryAnotherText, handleReset: handleReset });
});
